module.exports = __webpack_public_path__ + "img/1.a36efd90.png";